import { newToolFilterOAuthMcp } from "../oauth.ts";

export const listeneticMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://app.listenetic.com/apple-icon.png",
  url: "https://mcp.listenetic.com/v1/mcp",
  label: "Listenetic",
});
